import { Users, Building2, Tag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SectionHeader } from '../../components/SectionHeader';

export default function AdminDashboard() {
  return (
    <div className="space-y-8">
      <SectionHeader
        title="Administració del sistema"
        description="Gestiona usuaris, empreses, marques i configuració"
      />

      <div className="space-y-4">
        <h2 className="text-sm font-bold text-foreground">Accessos ràpids</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <Link
            to="/admin/users"
            className="flex items-center gap-4 p-6 rounded-lg border border-blue-200 bg-blue-50 shadow-card hover:border-blue-400 hover:shadow-md transition-all group"
          >
            <div className="p-3 rounded-lg bg-blue-100 group-hover:bg-blue-200 transition-colors">
              <Users className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <p className="font-semibold text-foreground">Usuaris</p>
              <p className="text-xs text-muted-foreground">Gestionar usuaris</p>
            </div>
          </Link>

          <Link
            to="/admin/companies"
            className="flex items-center gap-4 p-6 rounded-lg border border-green-200 bg-green-50 shadow-card hover:border-green-400 hover:shadow-md transition-all group"
          >
            <div className="p-3 rounded-lg bg-green-100 group-hover:bg-green-200 transition-colors">
              <Building2 className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <p className="font-semibold text-foreground">Empreses</p>
              <p className="text-xs text-muted-foreground">Gestionar empreses</p>
            </div>
          </Link>

          <Link
            to="/admin/brands"
            className="flex items-center gap-4 p-6 rounded-lg border border-purple-200 bg-purple-50 shadow-card hover:border-purple-400 hover:shadow-md transition-all group"
          >
            <div className="p-3 rounded-lg bg-purple-100 group-hover:bg-purple-200 transition-colors">
              <Tag className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <p className="font-semibold text-foreground">Marques</p>
              <p className="text-xs text-muted-foreground">Gestionar marques</p>
            </div>
          </Link>

          <Link
            to="/admin/settings"
            className="flex items-center gap-4 p-6 rounded-lg border border-amber-200 bg-amber-50 shadow-card hover:border-amber-400 hover:shadow-md transition-all group"
          >
            <div className="p-3 rounded-lg bg-amber-100 group-hover:bg-amber-200 transition-colors">
              <Tag className="w-6 h-6 text-amber-600" />
            </div>
            <div>
              <p className="font-semibold text-foreground">Configuració</p>
              <p className="text-xs text-muted-foreground">SMTP i ajustos del sistema</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
